module.exports = __webpack_public_path__ + "static/media/hw_wa_44.bcca3185.flv";